/**
 * SitePick front — 請求書払いの申請（販売導線 v2 Phase 3・docs/18 §5）の計測
 *
 * - /purchase/invoice/（フォーム）: view_invoice_form を 1 回/pageview（data-sp-invoice="form" の data-sp-* を読むだけ）。
 * - /purchase/invoice/done/（受付完了）: サーバが ack（data-sp-invoice-ack="1"）を描いたときだけ request_invoice を 1 回。
 *   ack は POST 成功の直後の 1 回だけサーバが出す（重複の申請・再読み込みでは出ない）。
 * - 会社名・メール・電話などの入力値は送らない（DOM の入力も読まない）。価格はサーバが描いた data-sp-value だけ。
 */

import { viewInvoiceForm, requestInvoice } from "./analytics.js";

/**
 * @param {string} key
 * @returns {boolean} すでに送ったか（sessionStorage が使えなければ false）。
 */
function seen(key) {
  try {
    if (window.sessionStorage.getItem(key)) {
      return true;
    }
    window.sessionStorage.setItem(key, "1");
  } catch {
    /* private mode 等 */
  }
  return false;
}

/**
 * @returns {void}
 */
export function initInvoice() {
  const form = document.querySelector("[data-sp-invoice=\"form\"]");
  if (form instanceof HTMLElement && !seen(`sp_inv_view_${window.location.pathname}${window.location.search}`)) {
    viewInvoiceForm(form.getAttribute("data-sp-item-id") || "", form.getAttribute("data-sp-invoice-entry") || "");
  }
  const done = document.querySelector("[data-sp-invoice=\"done\"][data-sp-invoice-ack=\"1\"]");
  if (done instanceof HTMLElement) {
    requestInvoice({
      item_id: done.getAttribute("data-sp-item-id") || "",
      invoice_entry: done.getAttribute("data-sp-invoice-entry") || "",
      value: Number.parseInt(done.getAttribute("data-sp-value") || "0", 10) || 0,
      currency: done.getAttribute("data-sp-currency") || "JPY",
    });
  }
}
